import {SMALL, TILE} from '../constants/index';

/**
 * generate unified breakpoints for sliders
 * 
 * @param {Object} opts object with settings
 * @param {string} opts.size slider size
 */
export function generateSliderBreakpoints(opts) {
  const mergedOpts = {
    size: TILE,
    ...opts
  }
  const baseSlidesCount = getBaseSliderCount(mergedOpts.size)

  return [
    {
      breakpoint: 3841,
      settings: {
        slidesToShow: baseSlidesCount + 3
      }
    },
    {
      breakpoint: 1715,
      settings: {
        slidesToShow: baseSlidesCount + 3
      }
    },
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: baseSlidesCount + 2
      }
    },
    {
      breakpoint: 925,
      settings: {
        slidesToShow: baseSlidesCount + 1
      }
    },
    {
      breakpoint: 585,
      settings: {
        slidesToShow: baseSlidesCount
      }
    }
  ]
}

function getBaseSliderCount(size) {
  if (size === SMALL) return 2

  return 1
}
